import {
  TKwikUIImageLoadingType,
  TKwikUIImageType,
  VKwikUIImageLoadingType,
  VKwikUIImageType
} from "./image.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isString = (x: string) => typeof x === "string";

  const methods = {
    altText: isString,
    class: isString,
    id: isString,
    imageSrc: isString,
    imageType: (x: TKwikUIImageType) => VKwikUIImageType.includes(x),
    loadingType: (x: TKwikUIImageLoadingType) =>
      VKwikUIImageLoadingType.includes(x),
    styles: isString
  };

  return methods[key] && methods[key](value);
};
